import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

export function NativeRouteSkeleton({ rows = 4, className }) {
  return (
    <div className={cn("native-v3-route-skeleton", className)} aria-label="Laddar innehåll">
      <Skeleton className="native-v3-silhouette-heading" />
      {Array.from({ length: rows }).map((_, index) => (
        <Skeleton className="native-v3-silhouette-row" key={index} />
      ))}
    </div>
  );
}

export function NativeSettingsSkeleton({ sections = 4 }) {
  return (
    <div className="native-v3-settings-skeleton" aria-label="Laddar inställningar">
      {Array.from({ length: sections }).map((_, index) => (
        <Skeleton
          className={cn("native-v3-silhouette-setting", index === 0 && "native-v3-silhouette-setting-large")}
          key={index}
        />
      ))}
    </div>
  );
}

export function NativeProtocolSkeleton() {
  return (
    <div className="native-v3-protocol-skeleton" aria-label="Laddar matchprotokoll">
      <Skeleton className="native-v3-protocol-skeleton-score-block" />
      <Skeleton className="native-v3-protocol-skeleton-ad" />
      <Skeleton className="native-v3-protocol-skeleton-program-block" />
    </div>
  );
}

export function NativeNotificationsSkeleton() {
  return (
    <div className="native-v3-notifications-skeleton" aria-label="Laddar notisinställningar">
      <Skeleton className="native-v3-silhouette-notification native-v3-silhouette-notification-large" />
      <Skeleton className="native-v3-silhouette-notification" />
      <Skeleton className="native-v3-silhouette-notification" />
      <Skeleton className="native-v3-silhouette-notification native-v3-silhouette-notification-quiet" />
    </div>
  );
}

export function NativeMatchPickerSkeleton({ rows = 3 }) {
  return (
    <div className="native-v3-picker-skeleton" aria-label="Laddar matcher">
      <Skeleton className="native-v3-silhouette-heading" />
      {Array.from({ length: rows }).map((_, index) => (
        <Skeleton className="native-v3-picker-skeleton-row" key={index} />
      ))}
    </div>
  );
}

export function NativeMatchGridSkeleton({ rows = 3 }) {
  return (
    <div className="native-v3-match-grid-skeleton" aria-label="Laddar matcher">
      {Array.from({ length: rows }).map((_, index) => (
        <Skeleton className="native-v3-match-grid-skeleton-card" key={index} />
      ))}
    </div>
  );
}

export function NativeOfficialMatchSkeleton() {
  return (
    <div className="native-v3-official-detail-skeleton" aria-label="Laddar matchkort">
      <Skeleton className="native-v3-official-detail-skeleton-summary" />
      <Skeleton className="native-v3-official-detail-skeleton-body" />
    </div>
  );
}

export function NativeProtocolListSkeleton({ rows = 3 }) {
  return (
    <div className="native-v3-protocol-list-skeleton" aria-label="Laddar protokoll">
      {Array.from({ length: rows }).map((_, index) => (
        <Skeleton className="native-v3-protocol-list-skeleton-card" key={index} />
      ))}
    </div>
  );
}

export function NativeSavedDetailSkeleton() {
  return (
    <div className="native-v3-saved-detail-skeleton" aria-label="Laddar sparat protokoll">
      <Skeleton className="native-v3-saved-detail-skeleton-summary" />
      <Skeleton className="native-v3-saved-detail-skeleton-body" />
    </div>
  );
}
